import { Fragment } from 'react'
import {
    flexRender,
    getCoreRowModel,
    getPaginationRowModel,
    useReactTable,
} from '@tanstack/react-table'
import styles from "./table.styles.module.scss"
import TablePagination from "./TablePagination"
interface IPaginationType {
    pageNumber: number
    pageSize: number
    totalPages: number
    totalRecords: number
}

interface IProps {
    data: { [key: string]: any }[]
    columns: Array<any>
    pagination?: boolean | undefined
    paginationObj?: IPaginationType | null
    onChangePagination?: (pageNumber: number, pageSize: number) => void
}


function HRMSTable(props: IProps) {
    const { data, columns, pagination, paginationObj, onChangePagination } = props
    const tableObj = {
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: pagination ? getPaginationRowModel() : undefined
    }

    const TableProps = useReactTable(paginationObj ? {
        ...tableObj,
        state: {
            pagination: {
                pageIndex: paginationObj?.pageNumber - 1 || 0,
                pageSize: paginationObj?.pageSize || 10
            }
        },
        pageCount: paginationObj?.totalPages,
        manualPagination: true,
    } : {
        ...tableObj
    })

    return (
        <Fragment>
            <div className={`${styles.tableScroll} table-responsive-xl`}>
                <table className={`${styles.hrmsTable} table table-hover`}>
                    <thead>
                        {TableProps.getHeaderGroups().map(headerGroup => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map(header => (
                                    <th key={header.id}>
                                        {header.isPlaceholder
                                            ? null
                                            : flexRender(
                                                header.column.columnDef.header,
                                                header.getContext()
                                            )}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {TableProps.getRowModel().rows.map(row => (
                            <tr key={row.id}>
                                {row.getVisibleCells().map(cell => (
                                    <td key={cell.id}>
                                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        {TableProps.getRowModel().rows.length <= 0 &&
                            <tr>
                                <td className='text-center' colSpan={TableProps.getAllColumns().length}>
                                    <span>
                                        No Data Available
                                    </span>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

            <TablePagination {...TableProps} onChangePagination={onChangePagination} />

        </Fragment>
    )
}

export default HRMSTable